module.exports = __webpack_public_path__ + "static/media/modal.4611ec20.jpg";